import classes from "./Header.module.scss";
import { clsx } from "clsx";
import { useTranslation } from "@/hooks/useTranslation";
import { getAsset } from "@/utils/assets";
import { useAppConfig } from "@/hooks/useAppConfig";

export type HeaderProps = {
  /**
   * Additional className
   */
  className?: string;
};

export function Header(props: HeaderProps) {
  const { className } = props;

  const t = useTranslation("_common");
  const { logo, home_url, charity_registration_number } = useAppConfig();

  return (
    <header className={clsx(classes.header, className)}>
      <div className={classes.row}>
        <a href={home_url} className={classes.logoLink}>
          <img
            src={logo.src}
            alt={logo.alt}
            width={logo.width}
            height={logo.height}
            className={classes.logo}
          />
        </a>

        <div className={classes.headerContent}>
          <div className={classes.secure}>
            <span className={classes.secureTitle}>
              <img
                src={getAsset("/images/lock-icon.svg")}
                alt=""
                width={18}
                height={18}
                className={classes.secureIcon}
              />
              {t("donation-is-secure")}
            </span>

            <span>
              {t("english-charity-registration", {
                number: `${charity_registration_number}`,
              })}
            </span>
          </div>

          <div className={classes.secureLogos}>
            <img
              src={getAsset("/images/secure-and-payment-logos.svg")}
              alt=""
              width={2157}
              height={122}
            />
          </div>
        </div>
      </div>
    </header>
  );
}
